import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { productionLogger } from '@/utils/production-logger';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0);
    
    // Track page view for GTM on route change
    if (typeof window !== 'undefined' && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        event: 'pageview',
        page: pathname,
        title: document.title,
        url: window.location.href
      });
      
      productionLogger.info('GTM Page View:', { pathname, title: document.title });
    }
    
    // Track GA4 page view
    if ((window as any).gtag) {
      (window as any).gtag('event', 'page_view', {
        page_path: pathname,
        page_title: document.title,
        page_location: window.location.href
      });
    }
    
    // Track Facebook Pixel page view
    if ((window as any).fbq) {
      (window as any).fbq('track', 'PageView');
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;